import {colors} from '../../../../shared/colors';
import {TypeServiceRequestStatusCode} from '../../../../shared/types/serviceRequest.types';
import {TypeAccountRoles} from '../../../../shared/types/user-account.types';

export const BASE_MAPS_URL = 'https://yandex.ru/maps';

export const EDIT_ADDRESS_ROLES = [
  TypeAccountRoles.MANAGER,
  TypeAccountRoles.PROJECT_MANAGER,
  TypeAccountRoles.DIRECTOR,
  TypeAccountRoles.FUNCTIONAL_ADMIN,
] satisfies TypeAccountRoles[];

export const EDIT_WORKERS_ROLES = [
  TypeAccountRoles.MANAGER,
  TypeAccountRoles.PROJECT_MANAGER,
  TypeAccountRoles.DIRECTOR,
  TypeAccountRoles.ADMIN,
  TypeAccountRoles.FUNCTIONAL_ADMIN,
  TypeAccountRoles.OWNER,
] satisfies TypeAccountRoles[];

export const EDIT_WORKERS_STATUSES: TypeServiceRequestStatusCode[] = [
  'CREATED',
  'READY_TO_PROCESS',
  'IN_PROGRESS',
  'DELAYED',
];

export const STYLES = {
  label: {
    backgroundColor: colors['bg--labelField'],
    border: `1px solid ${colors['border--white--bg']}`,
    textAlign: 'center',
    p: 0.5,
    width: '180px',
    fontSize: '14px',
  },
  data: {
    border: `1px solid ${colors['border--white--bg']}`,
    p: '4px 8px',
    width: 'calc(100% - 188px - 92px)',
    fontSize: '14px',
  },
  container: {
    padding: '1px',
    borderRadius: '6px',
  },
  companyName: {
    color: colors['icons--primary'],
    textDecoration: 'underline',
    cursor: 'pointer',
    letterSpacing: 0.5,
  },
  mainLayout: {
    justifyContent: 'space-between',
    '& > div:nth-child(2)': {width: '35%'},
    '& > div:nth-child(1)': {width: '60%'},
  },
  descriptionInput: {
    width: '100%',
    bgcolor: '#fff',
  },
} as const;
